import React, { Fragment, useState, useEffect } from 'react';
import { useFormFields } from '../../util/CommonUtils';
import MriSimmonsLogo from '../../components/common/MriSimmonsLogo';
import RenderForm from './RenderForm';
import { registerUser } from '../../actions/signUpActions';

const validateEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
function validate(fields) {
  // true means invalid, so our conditions got reversed
  return {
    email: fields.emailLogin.length === 0 && !validateEmail(fields.emailLogin),
    fName: fields.firstName.length === 0,
    lName: fields.lastName.length === 0,
    activationKey: fields.activationKey.length === 0,
  };
}

export default function Signup() {
  useEffect(() => {}, [fields]);
  const [isLoading, setIsLoading] = useState(false);
  const [showFormError, setShowFormError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({
    email: false,
    fName: false,
    lName: false,
    activationKey: false,
  });
  const [fields, handleFieldChange] = useFormFields({
    emailLogin: '',
    firstName: '',
    lastName: '',
    activationKey: '',
  });
  const resetValues = () => {
    Object.keys(fields).forEach(function (index) {
      fields[index] = '';
    });
    setErrors({
      email: false,
      fName: false,
      lName: false,
      activationKey: false,
    });
    setIsLoading(false);
  };
  const register = user => {
    setIsLoading(true);
    setIsSuccess('');
    setShowFormError(null);
    registerUser(user).then(response => {
      if (response.data.status === 422) {
        setIsSuccess('');
        setShowFormError(response.data.message);
        resetValues();
      }
      if (response.data.status === 200) {
        setIsSuccess(response.data.message);
        resetValues();
      }
      if (response.error) {
        setIsSuccess('');
        setShowFormError(response.error);
        resetValues();
      }
    });
  };
  const validateForm = () => {
    const email = fields.emailLogin.trim();
    const fName = fields.firstName.trim();
    const lName = fields.lastName.trim();
    const aKey = fields.activationKey.trim();
    return (
      email.length > 0 &&
      fName.length > 0 &&
      lName.length > 0 &&
      aKey.length > 0
    );
  };

  const handleSubmit = event => {
    event.preventDefault();
    let fieldError = validate(fields);
    setIsSuccess(false);
    const email = fields.emailLogin.trim();
    const fName = fields.firstName.trim();
    const lName = fields.lastName.trim();
    const activationKey = fields.activationKey.trim();
    const isEmailValid = validateEmail(email);
    let error = '';
    if (!fName || !lName || !email || !activationKey) {
      error = 'Please fill in the required fields before proceeding.';
    } else if (!isEmailValid) {
      error = 'Invalid email address.';
    } else if (!activationKey) {
      error = 'Please Enter the activation Key';
    } else if (!fName) {
      error = 'Please enter first name.';
    } else if (!lName) {
      error = 'Please enter last name.';
    }

    if (error) {
      setShowFormError(error);
      setErrors(fieldError);

      return;
    } else {
      register(fields);
    }
  };

  return (
    <Fragment>
      {isLoading && (
        <div id="nprogress">
          <div
            className="bar"
            style={{
              transform: 'translate3d(-0.6%, 0px, 0px)',
              transition: 'all 200ms ease 0s',
            }}
          >
            <div className="peg" />
          </div>
          <div className="spinner">
            <div className="spinner-icon" />
          </div>
        </div>
      )}

      <div className="registration-screen">
        <div className="registration-card-box">
          <div className="registration-card">
            <div className="registration-card-header">
              <div className="mri-simmons-logo">
                <MriSimmonsLogo height={66} width={336} />
              </div>
              Welcome to MRI Simmons Insights -- Client Self Registration
            </div>
            <div className="Signup">
              <RenderForm
                handleSubmit={handleSubmit}
                errors={errors}
                showErrorMsg={showFormError}
                fields={fields}
                isSuccess={isSuccess}
                handleFieldChange={handleFieldChange}
                validateForm={validateForm}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
